import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import { MarkdownOrText } from "../Common/MarkdownOrText";
export function PropertySimpleText(props) {
    const { property, textMode, sx } = props;
    const content = property.isLanguageDependent ? (_jsx(PropertySimpleTextLdp, { property: props.property, textMode: textMode })) : (_jsx(PropertySimpleTextValue, { property: property, textMode: textMode }));
    return _jsx(Box, { sx: sx, children: content });
}
function PropertySimpleTextLdp(props) {
    const { property, textMode } = props;
    const name = _jsx(MarkdownOrText, { text: property.name, textMode: textMode });
    const description = (_jsx(MarkdownOrText, { text: property.description, textMode: textMode }));
    return (_jsxs(Fragment, { children: [name, description] }));
}
function PropertySimpleTextValue(props) {
    const { property, textMode } = props;
    if (typeof property.value === "string") {
        return _jsx(MarkdownOrText, { text: property.value, textMode: textMode });
    }
    return _jsx(Fragment, { children: property.value });
}
//# sourceMappingURL=PropertySimpleText.js.map